module.exports = __webpack_public_path__ + "static/media/logo.6f35f464.png";